import { useState, useEffect } from 'react'
import { useIntl} from 'umi';

import { TYPES, DEFAULT_VALUE, DEFAULT_VALUE_MONTH } from '../_config/constant'

const useSelector = (props) => {
  const {
    defaultValue,
    onConfirm,
    onCancel,
    close
  } = props
  const [rangeDate, setRangeDate] = useState(defaultValue?.value ?? DEFAULT_VALUE?.value)
  const [type, setType] = useState(defaultValue?.type ?? DEFAULT_VALUE?.type)
  const [errorMessage, setErrorMessage] = useState(['', ''])
  const { formatMessage } = useIntl()
  const getErrorMessage = (rangeDate, type) => {
  // message 优先级，索引越大优先级越低
  const errorMessageList = [formatMessage({id:'common_publish_filter_please'}),  formatMessage({id:'common_publish_filter_date_out'}),  formatMessage({id:'common_publish_filter_date_should'})]
   
    const isInValid = (value) => {
      // 不能非数字、小于0、小数
      return isNaN(value) || Number(value) <= 0 || parseInt(value) !== parseFloat(value)
    }

    const outOfRange = (value) => {
      const max = type === TYPES[0].value ? 1095 : 36
      return value > max
    }

    const outOfMaxLength = (rangeDate, type) => {
      return Math.abs(rangeDate[0] - rangeDate[1]) > (type === TYPES[0].value ? 364 : 11)
    }

    let errorMessgeStart = (() => {
      if ((Number(rangeDate[0]) > Number(rangeDate[1]) && rangeDate[1]) || isInValid(rangeDate[0])) {
        return errorMessageList[0]
      }
      if (outOfRange(rangeDate[0])) {
        return errorMessageList[1]
      }
      return ''
    })()
    let errorMessageEnd = (() => {
      if (isInValid(rangeDate[1])) {
        return errorMessageList[0]
      }
      if (outOfRange(rangeDate[1])) {
        return errorMessageList[1]
      }
      if (Number(rangeDate[0]) < Number(rangeDate[1]) && outOfMaxLength(rangeDate, type)) {
        return errorMessageList[2]
      }
      return ''
    })()

    if (errorMessageEnd && errorMessgeStart) {
      const startIndex = errorMessageList.findIndex((message) => message === errorMessgeStart)
      const endIndex = errorMessageList.findIndex((message) => message === errorMessageEnd)
      if (startIndex >= endIndex) {
        errorMessgeStart = ''
      } else {
        errorMessageEnd = ''
      }
    }

    return [errorMessgeStart, errorMessageEnd]
  }

  const handleTypeChange = (type) => {
    const errorMessage = getErrorMessage(rangeDate, type)
    setErrorMessage(errorMessage)
    setType(type)
    setRangeDate(type === 'Day' ? DEFAULT_VALUE?.value : DEFAULT_VALUE_MONTH?.value)
  }

  const handleRangeDateChange = (newRangeDate) => {
    const errorMessage = getErrorMessage(newRangeDate, type)
    setErrorMessage(errorMessage)
    setRangeDate(newRangeDate)
  }

  const handleConfirm = () => {
    if (errorMessage?.some(item => item)) return
    onConfirm?.(rangeDate, type)
    close?.()
  }

  const handleCancel = () => {
    onCancel?.()
    close?.()
  }

  useEffect(() => {
    setErrorMessage(getErrorMessage(rangeDate, type))
  }, [rangeDate, type])

  return {
    type,
    rangeDate,
    errorMessage,
    handleConfirm,
    handleCancel,
    handleTypeChange,
    handleRangeDateChange
  }
}

export default useSelector